import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Invoice from './icon-goal-invoice.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Invoice {...validProps} />;
}
SvgComponent.iconName = 'goal-invoice';

export const GoalInvoiceIcon = svgIconWrapper(SvgComponent);
